import { useEffect } from 'react';
import site from './site.json';

export default site;

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

// Keep the tab title and meta tags in sync when navigating inside the app.
// The server renders the same values for the first page load (logo_saas/seo.py).
export const usePageMeta = (page) => {
  useEffect(() => {
    if (!page) return;
    document.title = page.title;
    setMeta('meta[name="description"]', 'content', page.description);
    if (page.path) {
      const url = site.siteUrl + (page.path === '/' ? '/' : page.path);
      setMeta('link[rel="canonical"]', 'href', url);
      setMeta('meta[property="og:url"]', 'content', url);
    }
    setMeta('meta[property="og:title"]', 'content', page.title);
    setMeta('meta[property="og:description"]', 'content', page.description);
  }, [page]);
};
